import "@/assets/img/tips/ic-waiting.gif";
import { defineComponent } from 'vue';
export default defineComponent({
  name: "TipsLoading",
  props: {
    show: {
      type: Boolean,
      "default": false,
      required: true
    }
  }
});